export default "__VITE_ASSET__DEYPY3kU__"